webpackJsonp([264598414423048],{

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutPageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _layout = __webpack_require__(22);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _structuredData = __webpack_require__(28);
	
	var _structuredData2 = _interopRequireDefault(_structuredData);
	
	var _seoTags = __webpack_require__(27);
	
	var _seoTags2 = _interopRequireDefault(_seoTags);
	
	var _reactRouterDom = __webpack_require__(23);
	
	var _breadcrumbs = __webpack_require__(45);
	
	var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);
	
	var _jumbotron = __webpack_require__(104);
	
	var _jumbotron2 = _interopRequireDefault(_jumbotron);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage(_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	  var post = data.markdownRemark;
	
	  var title = post.frontmatter.title;
	  var seo = post.frontmatter.seo;
	  var html = post.html;
	
	  return _react2.default.createElement(
	    _layout2.default,
	    null,
	    _react2.default.createElement(_structuredData2.default, { isReview: false, isBreadcrumbs: true, title: title, pagePath: location.pathname }),
	    _react2.default.createElement(_seoTags2.default, {
	      title: '' + seo.title,
	      description: '' + seo.description
	    }),
	    _react2.default.createElement(_jumbotron2.default, {
	      isIndexPage: true,
	      title: title,
	      subheading: 'my story & values',
	      image: '/img/deposit_suv-on-wild-mountain-road.jpg',
	      alt: 'Autokwix - history and my values'
	    }),
	    _react2.default.createElement(_breadcrumbs2.default, { currentPage: title }),
	    _react2.default.createElement(
	      'div',
	      { className: 'about' },
	      _react2.default.createElement(
	        'div',
	        { className: 'about__wrapper' },
	        _react2.default.createElement('div', { className: 'about__text', dangerouslySetInnerHTML: { __html: html } })
	      )
	    )
	  );
	};
	
	AboutPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactRouterDom.withRouter)(AboutPage);
	var aboutPageQuery = exports.aboutPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-about-page-js-87320297d74922226d93.js